import { render, staticRenderFns } from "./RevenueApportionment.vue?vue&type=template&id=33a2bf4f&scoped=true"
import script from "./RevenueApportionment.vue?vue&type=script&lang=js"
export * from "./RevenueApportionment.vue?vue&type=script&lang=js"
import style0 from "./RevenueApportionment.vue?vue&type=style&index=0&id=33a2bf4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a2bf4f",
  null
  
)

export default component.exports